"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var state = {
  activeIndex: 0,
  promotionActiveIndex: 0,
  officialAccountActiveIndex: 0,
  personalActiveIndex: undefined,
  officialItemActiveIndex: 0,
  isGoOfficial: 0,
  kfcAccountActiveIndex: 0,
  movieShowDialog: false,
  slideActive: 0,
  activeIndexMini: 0,
  selectItem: 0,
  isOpenDouyin: true
};
var mutations = {
  SET_ACTIVE_slideActive: function SET_ACTIVE_slideActive(state, activeIndex) {
    state.slideActive = activeIndex;
  },
  SET_ACTIVE_INDEX: function SET_ACTIVE_INDEX(state, activeIndex) {
    state.activeIndex = activeIndex;
  },
  SET_PROMOTION_ACTIVE_INDEX: function SET_PROMOTION_ACTIVE_INDEX(state, activeIndex) {
    state.promotionActiveIndex = activeIndex;
  },
  SET_OFFICIAL_ACCOUNT_ACTIVE_INDEX: function SET_OFFICIAL_ACCOUNT_ACTIVE_INDEX(state, activeIndex) {
    state.officialAccountActiveIndex = activeIndex;
  },
  SET_PERSONAL_ACTIVE_INDEX: function SET_PERSONAL_ACTIVE_INDEX(state, activeIndex) {
    state.personalActiveIndex = activeIndex;
  },
  SET_OFFICIAL_ITEM_ACTIVE_INDEX: function SET_OFFICIAL_ITEM_ACTIVE_INDEX(state, activeIndex) {
    state.officialItemActiveIndex = activeIndex;
  },
  SET_IS_GO_OFFICIAL: function SET_IS_GO_OFFICIAL(state, isGoOfficial) {
    state.isGoOfficial = isGoOfficial;
  },
  SET_KFC_ACCOUNT_ACTIVE_INDEX: function SET_KFC_ACCOUNT_ACTIVE_INDEX(state, activeIndex) {
    state.kfcAccountActiveIndex = activeIndex;
  },
  SET_MOVIE_SHOW_DIALOG: function SET_MOVIE_SHOW_DIALOG(state, movieShowDialog) {
    state.movieShowDialog = movieShowDialog;
  },
  SET_ACTIVE_INDEX_MINI: function SET_ACTIVE_INDEX_MINI(state, data) {
    state.activeIndexMini = data;
  },
  SET_SELECT_ITEM: function SET_SELECT_ITEM(state, data) {
    state.selectItem = data;
  },
  SET_ISOPEN_DOUYIN: function SET_ISOPEN_DOUYIN(state, data) {
    state.isOpenDouyin = data;
  }
};
var actions = {
  changeActiveIndex: function changeActiveIndex(_ref, activeIndex) {
    var commit = _ref.commit;
    commit('SET_ACTIVE_INDEX', activeIndex);
  },
  changePromotionActiveIndex: function changePromotionActiveIndex(_ref2, activeIndex) {
    var commit = _ref2.commit;
    commit('SET_PROMOTION_ACTIVE_INDEX', activeIndex);
  },
  changeOfficialAccountActiveIndex: function changeOfficialAccountActiveIndex(_ref3, activeIndex) {
    var commit = _ref3.commit;
    commit('SET_OFFICIAL_ACCOUNT_ACTIVE_INDEX', activeIndex);
  },
  changePersonalActiveIndex: function changePersonalActiveIndex(_ref4, activeIndex) {
    var commit = _ref4.commit;
    commit('SET_PERSONAL_ACTIVE_INDEX', activeIndex);
  },
  changeOfficialItemActiveIndex: function changeOfficialItemActiveIndex(_ref5, activeIndex) {
    var commit = _ref5.commit;
    commit('SET_OFFICIAL_ITEM_ACTIVE_INDEX', activeIndex);
  },
  changeIsGoOfficial: function changeIsGoOfficial(_ref6, isGoOfficial) {
    var commit = _ref6.commit;
    commit('SET_IS_GO_OFFICIAL', isGoOfficial);
  },
  changeKfcAccountActiveIndex: function changeKfcAccountActiveIndex(_ref7, activeIndex) {
    var commit = _ref7.commit;
    commit('SET_KFC_ACCOUNT_ACTIVE_INDEX', activeIndex);
  },
  changeMovieShowDialog: function changeMovieShowDialog(_ref8, movieShowDialog) {
    var commit = _ref8.commit;
    commit('SET_MOVIE_SHOW_DIALOG', movieShowDialog);
  },
  changeActiveIndexMini: function changeActiveIndexMini(_ref9, activeIndexMini) {
    var commit = _ref9.commit;
    commit('SET_ACTIVE_INDEX_MINI', activeIndexMini);
  },
  changeSelectItem: function changeSelectItem(_ref10, selectItem) {
    var commit = _ref10.commit;
    commit('SET_SELECT_ITEM', selectItem);
  },
  changeIsOpenDouyin: function changeIsOpenDouyin(_ref11, isOpenDouyin) {
    var commit = _ref11.commit;
    commit('SET_ISOPEN_DOUYIN', isOpenDouyin);
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports["default"] = _default;


// WEBPACK FOOTER //
// ./src/store/modules/dist/nav.dev.js